export const FONT_FAMILY_STACKS = {
  sans: '"Inter","Inter Fallback",Helvetica,Arial,sans-serif',
  serif: 'ui-serif,Georgia,Cambria,"Times New Roman",Times,serif',
  mono: '"GeistMono",ui-monospace,SFMono-Regular,Roboto Mono,Menlo,Monaco,Liberation Mono,DejaVu Sans Mono,Courier New,monospace',
} as const;

export type FontFamilyOptionKey = keyof typeof FONT_FAMILY_STACKS;

export type FontFamilyOption = {
  value: FontFamilyOptionKey;
  labelId: string;
  defaultMessage: string;
  stack: string;
};

export const FONT_FAMILY_OPTIONS: FontFamilyOption[] = [
  {
    value: "sans",
    labelId: "settings.fontInter",
    defaultMessage: "Arial",
    stack: FONT_FAMILY_STACKS.sans,
  },
  {
    value: "serif",
    labelId: "settings.fontTimesNewRoman",
    defaultMessage: "Times New Roman",
    stack: FONT_FAMILY_STACKS.serif,
  },
  {
    value: "mono",
    labelId: "settings.fontMonospace",
    defaultMessage: "Monospace",
    stack: FONT_FAMILY_STACKS.mono,
  },
];

export const isFontFamilyOptionKey = (
  value: string | null | undefined
): value is FontFamilyOptionKey => {
  if (!value) return false;
  return FONT_FAMILY_OPTIONS.some((option) => option.value === value);
};
